import _ from 'lodash';
import {connect} from 'react-redux';
import Component from './Component';

export default connect(
  (state) => ({
    isCollapsed: _.get(state, 'sidebar.isCollapsed'),
    isShowClippingPanel: _.get(state, 'sidebar.isShowClippingPanel'),
    isInited: _.get(state, 'base.inited'),
    userId: _.get(state, 'me.id'),
    accessToken: localStorage.access_token,
    router: _.get(state, 'router.location.pathname'),
    subject: _.get(state, 'subject'),
  })
)(Component);



/** WEBPACK FOOTER **
 ** ./src/app/modules/base/components/Container.js
 **/